import { UserLookupFilter } from '../shared/user-lookup-filter.model';
import * as adminActions from './admin.actions';

export interface AdminState {
  userLookup: {
    showing: string;
    filter: UserLookupFilter;
    userLkupSelectedRow: any;
  };
}

export const initialState: AdminState = {
  userLookup: {
    showing: 'grid',
    filter: null,
    userLkupSelectedRow: null,
  },
};

export function adminReducer(state = initialState, action: adminActions.AdminActions) {
  switch (action.type) {
    case adminActions.USER_LOOKUP_INIT:
      return initialState;
    case adminActions.USER_LOOKUP_SET_FILTER:
      return {
        ...state,
        userLookup: {
          ...state.userLookup,
          filter: action.filter,
        },
      };
    case adminActions.USER_LOOKUP_CLEAR_FILTER:
      return {
        ...state,
        userLookup: {
          ...state.userLookup,
          filter: null,
        },
      };
    case adminActions.USER_LOOKUP_SET_SHOWING:
      return {
        ...state,
        userLookup: {
          ...state.userLookup,
          showing: action.area,
        },
      };
    case adminActions.USER_LOOKUP_SELECT_ROW:
      return {
        ...state,
        userLookup: {
          ...state.userLookup,
          userLkupSelectedRow: action.row,
        },
      };
    case adminActions.USER_LOOKUP_CLEAR_SELECT_ROW:
      return {
        ...state,
        userLookup: {
          ...state.userLookup,
          userLkupSelectedRow: null,
        },
      };
    case adminActions.USER_DETAIL_LOOKUP_SET_SHOWING:
      return {
        ...state,
        userLookup: {
          ...state.userLookup,
          showing: action.area,
        },
      };
    default:
      return state;
  }
}
